module.exports = __webpack_public_path__ + "img/logo.d1c11516.png";